/** PM Message Actions — action menus, reply, mobile interactions, swipe-to-reply. */

window.toggleMessageActions = function(event, msgId) {
  event.preventDefault();
  event.stopPropagation();

  // On mobile, use the bottom sheet instead of inline dropdown
  if (window.matchMedia('(max-width: 639px)').matches && window.openMessageActionsSheet) {
    window.openMessageActionsSheet(msgId);
    return;
  }

  const $menu = $("#msg-actions-" + msgId);
  const $allMenus = $(".msg-actions-menu");

  // Close all other menus
  $allMenus.not($menu).addClass("hidden");

  // Toggle this menu
  $menu.toggleClass("hidden");

  // Position the menu using fixed coordinates so it escapes the scroll container
  if (!$menu.hasClass("hidden")) {
    const button = $(event.currentTarget);
    const buttonRect = button[0].getBoundingClientRect();

    // Use fixed positioning to break out of overflow:auto stacking context
    $menu.css({ position: "fixed", top: "", bottom: "", left: "", right: "" });

    var menuTop = buttonRect.bottom + 4;
    var menuRight = window.innerWidth - buttonRect.right;

    // Measure menu now that it's visible
    const menuRect = $menu[0].getBoundingClientRect();

    // Flip above button if it would go off the bottom
    if (menuTop + menuRect.height > window.innerHeight) {
      menuTop = buttonRect.top - menuRect.height - 4;
    }

    // Keep within left edge
    if (buttonRect.right - menuRect.width < 0) {
      menuRight = window.innerWidth - buttonRect.left - menuRect.width;
    }

    $menu.css({ top: menuTop + "px", right: menuRight + "px" });
  }
};

/**
 * Reply to a message - activates reply mode in the compose box
 */
window.replyToMessage = function(msgId) {
  // Close all action menus
  $(".msg-actions-menu").addClass("hidden");

  var $msg = $("#msg_" + msgId);
  var senderName = $msg.data("sender-name") || "";
  var msgPreview = $msg.data("msg-preview") || "";

  $("#reply_preview_sender").text(senderName);
  $("#reply_preview_text").text(msgPreview);
  $("#reply_to_id").val(String(msgId));
  $("#reply_preview_container").removeClass("hidden");

  $("#message").focus();
};

/**
 * Cancel reply mode - clears the reply preview
 */
window.cancelReply = function() {
  $("#reply_preview_container").addClass("hidden");
  $("#reply_preview_sender").text("");
  $("#reply_preview_text").text("");
  $("#reply_to_id").val("");
};

// ---------------------------------------------------------------------------
// Mobile: Tap on message → reveal reply + more buttons inline
// Desktop: CSS group-hover handles it (sm:opacity-0 → sm:group-hover:opacity-100)
// ---------------------------------------------------------------------------
(function() {
  var activeMsgId = null;
  var activeSheetMsgId = null;
  var sheetCloseTimer = null;

  // Long-press state. A photo opens the lightbox on tap, so long-press is the
  // way to reach its react/reply/more toolbar on touch devices.
  var LONG_PRESS_MS = 500;
  var longPressTimer = null;
  // After a long-press fires we must swallow exactly one click: the synthetic
  // click the browser emits for the same photo on release. Scope the suppression
  // to that photo element so it can never swallow a tap on anything else (a
  // concurrent second finger, a later click elsewhere on the page). A timer
  // disarms it after the window in case no release click is emitted (iOS,
  // touchcancel, a context menu), so a detached node is never retained.
  var SUPPRESS_CLICK_MS = 1000;
  var suppressClickEl = null;
  var suppressClickTimer = null;

  function isMobile() {
    return window.matchMedia('(max-width: 639px)').matches;
  }

  function clearLongPress() {
    if (longPressTimer) {
      clearTimeout(longPressTimer);
      longPressTimer = null;
    }
  }

  function disarmSuppressClick() {
    suppressClickEl = null;
    if (suppressClickTimer) {
      clearTimeout(suppressClickTimer);
      suppressClickTimer = null;
    }
  }

  function getMsgId(el) {
    var $msg = $(el).closest('.pm_msg');
    if (!$msg.length) return null;
    var id = $msg.attr('id');
    return id ? id.replace('msg_', '') : null;
  }

  function getMsgData(msgId) {
    var $msg = $('#msg_' + msgId);
    if (!$msg.length) return null;
    var currentUserId = $('meta[name="user-id"]').attr('content') || '';
    var senderId = String($msg.data('sender-id') || '');
    return {
      id: msgId,
      senderName: $msg.data('sender-name') || '',
      preview: $msg.data('msg-preview') || '',
      isOwnMessage: senderId === currentUserId || $msg.data('optimistic') === true
    };
  }

  // Show inline action buttons on a specific message (mobile tap-to-reveal)
  function showMobileActions(msgId) {
    if (activeMsgId === msgId) return;
    hideMobileActions();

    activeMsgId = msgId;
    var $msg = $('#msg_' + msgId);
    $msg.addClass('mobile-actions-visible');

    // Initialize Lucide icons that may not have been processed while hidden
    if (window.LucideIcons) {
      window.LucideIcons.initialize($msg[0]);
    }
  }

  // Hide inline action buttons
  function hideMobileActions() {
    if (!activeMsgId) return;
    $('#msg_' + activeMsgId).removeClass('mobile-actions-visible');
    activeMsgId = null;
  }

  // Mobile tap handler. A tap on a message bubble toggles that message's action
  // buttons; a tap anywhere else (the empty row gutter, the avatar/name header,
  // another message, or outside the list) dismisses an open toolbar. One handler
  // so the same click can't both reveal and dismiss.
  $(document).on('click', function(e) {
    if (!isMobile()) return;

    var $t = $(e.target);

    // Let the action controls handle their own taps (toolbar buttons, the
    // dropdown, the bottom sheet, the reaction popover, the reaction picker sheet).
    if ($t.closest('.msg-hover-action, .msg-actions-menu, #msg-actions-sheet, #pm-reaction-sheet, .pm-reaction-popover').length) {
      return;
    }

    var $msg = $t.closest('#threads_right .pm_msg');
    // A tap counts as "on the bubble" only when it lands inside the bubble
    // wrapper and not on a link/button (photos are links → lightbox path).
    var onBubble = $msg.length > 0 &&
      $t.closest('.pm-msg-bubble-wrap').length > 0 &&
      $t.closest('a, button').length === 0 &&
      !$msg.hasClass('optimistic-msg');

    if (onBubble) {
      var msgId = getMsgId($msg[0]);
      if (!msgId) return;
      if (activeMsgId === msgId) {
        hideMobileActions();
      } else {
        showMobileActions(msgId);
      }
      return;
    }

    // Tap off the bubble → dismiss any open actions.
    if (activeMsgId) {
      hideMobileActions();
    }
  });

  // After a long-press reveals the toolbar, the browser still fires a click on
  // release. Swallow that one click (capture phase, before the delegated
  // lightbox/tap handlers) so the photo's lightbox does not also open. Scoped to
  // the long-pressed photo: a click on any other element is left untouched.
  // `stopPropagation` (not Immediate) keeps sibling capture handlers like the
  // reaction popover's outside-click dismissal working.
  document.addEventListener('click', function(e) {
    if (suppressClickEl && suppressClickEl.contains(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      disarmSuppressClick();
    }
  }, true);

  // Suppress the native long-press context menu on photos (Android) so our
  // long-press gesture stays clean. iOS is handled by -webkit-touch-callout on
  // the photo link and image.
  $(document).on('contextmenu', '#threads_right a[data-lightbox]', function(e) {
    if (isMobile()) e.preventDefault();
  });

  // Open the bottom sheet (for "more" actions on mobile)
  window.openMessageActionsSheet = function(msgId) {
    var data = getMsgData(msgId);
    if (!data) return;

    activeSheetMsgId = msgId;

    var previewText = data.senderName ? data.senderName + ': ' + data.preview : data.preview;
    $('#msg-actions-sheet-preview').text(previewText);

    var $report = $('#msg-actions-sheet-report');
    if (data.isOwnMessage) {
      $report.addClass('hidden');
    } else {
      $report.removeClass('hidden');
    }

    // Correct is offered only on the other user's text-bearing messages
    // (data-msg-raw carries the raw text the correction editor needs).
    var $correct = $('#msg-actions-sheet-correct');
    var hasRawText = !!$('#msg_' + msgId).attr('data-msg-raw');
    if (data.isOwnMessage || !hasRawText) {
      $correct.addClass('hidden');
    } else {
      $correct.removeClass('hidden');
    }

    // Cancel any pending close animation
    if (sheetCloseTimer) {
      clearTimeout(sheetCloseTimer);
      sheetCloseTimer = null;
    }

    var $sheet = $('#msg-actions-sheet');
    var $panel = $('#msg-actions-sheet-panel');
    $sheet.removeClass('hidden');

    if (window.scrollLock) window.scrollLock.lock();
    if (navigator.vibrate) navigator.vibrate(10);

    requestAnimationFrame(function() {
      $panel[0].style.transform = 'translateY(0)';
    });
  };

  // Close the bottom sheet
  window.closeMessageActionsSheet = function() {
    var $sheet = $('#msg-actions-sheet');
    var $panel = $('#msg-actions-sheet-panel');

    $panel[0].style.transform = 'translateY(100%)';

    sheetCloseTimer = setTimeout(function() {
      sheetCloseTimer = null;
      $sheet.addClass('hidden');
      activeSheetMsgId = null;
      if (window.scrollLock) window.scrollLock.unlock();
    }, 200);
  };

  // Wire up sheet action buttons
  $(document).on('click', '#msg-actions-sheet-backdrop', function() {
    window.closeMessageActionsSheet();
  });

  $(document).on('click', '#msg-actions-sheet-reply', function() {
    if (activeSheetMsgId) window.replyToMessage(activeSheetMsgId);
    window.closeMessageActionsSheet();
  });

  $(document).on('click', '#msg-actions-sheet-correct', function() {
    var msgId = activeSheetMsgId;
    window.closeMessageActionsSheet();
    if (msgId) window.correctMessage(msgId);
  });

  $(document).on('click', '#msg-actions-sheet-report', function() {
    if (activeSheetMsgId) window.report_message(activeSheetMsgId);
    window.closeMessageActionsSheet();
  });

  $(document).on('click', '#msg-actions-sheet-delete', function() {
    var msgId = activeSheetMsgId;
    window.closeMessageActionsSheet();
    if (msgId) window.delete_message(msgId);
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && activeSheetMsgId) {
      window.closeMessageActionsSheet();
    }
  });

  // -------------------------------------------------------------------------
  // Mobile swipe-to-reply
  // -------------------------------------------------------------------------
  var SWIPE_THRESHOLD = 60;
  var swipeStartX = 0;
  var swipeStartY = 0;
  var swipeMsgEl = null;
  var swiping = false;
  var swipeTriggered = false;

  // Reusable reply hint icon shown to the left of the swiped message
  var $swipeHint = $('<div class="swipe-reply-hint"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 17 4 12 9 7"></polyline><path d="M20 18v-2a4 4 0 0 0-4-4H4"></path></svg></div>');

  function showSwipeHint(msgEl, progress) {
    var $msg = $(msgEl);
    var container = $msg.parent()[0];
    if (!$swipeHint[0].parentNode && container) {
      // Append to the scroll container so it stays fixed while the message translates
      $(container).append($swipeHint);
    }
    // Position vertically centered on the message body
    var msgBody = $msg.find('.msg_body')[0];
    if (msgBody && container) {
      var bodyRect = msgBody.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      $swipeHint[0].style.top = (bodyRect.top - containerRect.top + container.scrollTop + bodyRect.height / 2) + 'px';
    }
    var scale = Math.min(progress, 1);
    $swipeHint[0].style.opacity = scale;
    $swipeHint[0].style.transform = 'translateY(-50%) scale(' + (0.5 + 0.5 * scale) + ')';
  }

  function hideSwipeHint() {
    $swipeHint.detach();
  }

  $(document).on('touchstart', '#threads_right .pm_msg', function(e) {
    if (!isMobile()) return;
    if ($(e.currentTarget).hasClass('optimistic-msg')) return;
    var touch = e.originalEvent.touches[0];
    swipeStartX = touch.clientX;
    swipeStartY = touch.clientY;
    swipeMsgEl = e.currentTarget;
    swiping = false;
    swipeTriggered = false;

    // Arm long-press on a photo to reveal its actions toolbar. A short tap still
    // opens the lightbox; holding without moving reveals react/reply/more.
    clearLongPress();
    var photoEl = $(e.target).closest('a[data-lightbox]')[0];
    if (photoEl) {
      var rowEl = e.currentTarget;
      longPressTimer = setTimeout(function() {
        longPressTimer = null;
        // Swallow the release click on this exact photo so the lightbox doesn't
        // also open. Auto-disarm after the window in case no click is emitted.
        disarmSuppressClick();
        suppressClickEl = photoEl;
        suppressClickTimer = setTimeout(disarmSuppressClick, SUPPRESS_CLICK_MS);
        // The long-press consumed the gesture: drop swipe-to-reply tracking so a
        // later drag can't also fire a reply.
        swipeMsgEl = null;
        if (navigator.vibrate) navigator.vibrate(10);
        var msgId = getMsgId(rowEl);
        if (msgId) showMobileActions(msgId);
      }, LONG_PRESS_MS);
    }
  });

  $(document).on('touchmove', '#threads_right .pm_msg', function(e) {
    // Any real movement (scroll or swipe) cancels a pending long-press.
    if (longPressTimer) {
      var lt = e.originalEvent.touches[0];
      if (Math.abs(lt.clientX - swipeStartX) > 10 || Math.abs(lt.clientY - swipeStartY) > 10) {
        clearLongPress();
      }
    }
    if (!swipeMsgEl || swipeTriggered) return;
    var touch = e.originalEvent.touches[0];
    var dx = touch.clientX - swipeStartX;
    var dy = Math.abs(touch.clientY - swipeStartY);

    // Only track horizontal right swipe; ignore if vertical movement dominates
    if (dy > 30 && !swiping) {
      swipeMsgEl = null;
      return;
    }

    if (dx > 10) {
      swiping = true;
      var offset = Math.min(dx, 80);
      swipeMsgEl.style.transform = 'translateX(' + offset + 'px)';
      swipeMsgEl.style.transition = 'none';

      // Animate reply hint icon based on progress toward threshold
      showSwipeHint(swipeMsgEl, dx / SWIPE_THRESHOLD);

      if (dx >= SWIPE_THRESHOLD && !swipeTriggered) {
        swipeTriggered = true;
        if (navigator.vibrate) navigator.vibrate(10);
      }
    }
  });

  $(document).on('touchend touchcancel', '#threads_right .pm_msg', function() {
    clearLongPress();
    if (!swipeMsgEl) return;
    var el = swipeMsgEl;

    // Animate back
    el.style.transition = 'transform 0.2s ease-out';
    el.style.transform = '';
    hideSwipeHint();

    if (swipeTriggered) {
      var msgId = getMsgId(el);
      if (msgId) {
        window.replyToMessage(msgId);
      }
    }

    // Clean up after animation
    setTimeout(function() {
      el.style.transition = '';
    }, 200);

    swipeMsgEl = null;
    swiping = false;
    swipeTriggered = false;
  });
})();
